import { useAdminData } from '../admin/AdminDataContext';
import { EmptyWorkspacePage } from './EmptyWorkspacePage';
import { MapPage } from './MapPage';

export function WorkspaceGate() {
  const { mapSettings, mapSettingsLoading, mapSettingsError } = useAdminData();

  if (mapSettingsLoading) {
    return (
      <div className="flex h-screen w-full items-center justify-center bg-bg-canvas">
        <p className="text-sm text-text-secondary">Загрузка пространства…</p>
      </div>
    );
  }

  if (mapSettingsError) {
    return (
      <div className="flex h-screen w-full items-center justify-center bg-bg-canvas">
        <p className="text-sm font-medium text-status-danger">{mapSettingsError}</p>
      </div>
    );
  }

  return mapSettings ? <MapPage /> : <EmptyWorkspacePage />;
}
